// extracted by mini-css-extract-plugin
module.exports = {"nav":"Menu_nav__3IWQA","chiRhoLink":"Menu_chiRhoLink__3djvS","ul":"Menu_ul__2prWi","li":"Menu_li__Nx2on","link":"Menu_link__PwcJp","menuOpen":"Menu_menuOpen__1xDiE"};